/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';

export const queue = (state = defaultState.queue, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        keys = [];

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.QUEUE_LIST:
                keys = Object.keys(action.payload);

                if (keys.length === 0 || keys.length < 20) {
                    nextState.hasMore = false;
                }

                for (i = 0; i < keys.length; ++i) {
                    if (nextState.list.find(({id}) => { id === action.payload[keys[i]].id}) === undefined) {
                        nextState.list.push(action.payload[keys[i]]);
                    }
                }
                break;

            case constants.QUEUE_ORDER_UPDATE:
                keys = Object.keys(action.payload);
                nextState.list = [];
                for (i = 0; i < keys.length; ++i) {
                    nextState.list.push(action.payload[keys[i]]);
                }
                break;

            case constants.QUEUE_DELETE:
                // noop for success
                break;

            case constants.QUEUE_UPDATE:
                // noop for success
                break;


            case constants.QUEUE_CALENDAR_LIST:
                nextState.calendar.list = action.payload;
                break;

            case constants.QUEUE_CALENDAR_DETAIL:
                nextState.calendar.detail = action.payload;
                break;

            default:
                break;

        }
    } else if (action.status === constants.STATE_TXRX && action.type === constants.QUEUE_LIST) {
        // build in a way to reset the queue since switching from one queue
        // to another won't trigger the key[0] === 0 switch above if the queue is empty
        if (action.post.reset !== undefined && action.post.reset) {
            nextState.list = [];
            nextState.hasMore = true;
        }
    } else if (action.status === constants.STATE_TXRX && action.type === constants.QUEUE_DELETE) {
        // also reset the list when a user unleashes the power of the sledgehammer (delete all)
        if (action.post.sledgehammer !== undefined && action.post.sledgehammer) {
            nextState.list = [];
            nextState.hasMore = true;
        }
    }


    return nextState;
};
